import { useEffect, useRef, useState } from 'react'
import { requestDownload } from '../lib/api'

function emailValid(e:string){
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)
}

export default function EmailRequestForm({ itemId }:{ itemId:string }){
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle'|'sending'|'ok'|'err'>('idle')
  const [err, setErr] = useState('')
  const captchaRef = useRef<HTMLDivElement>(null)
  const [token, setToken] = useState('')

  useEffect(()=>{
    const w:any = window
    const render = () => {
      if(!captchaRef.current || !w.turnstile) return
      // Clear any existing widget first to prevent duplicates
      captchaRef.current.innerHTML = ''
      w.turnstile.render(captchaRef.current, {
        sitekey: import.meta.env.VITE_TURNSTILE_SITEKEY,
        callback: (t:string)=>{
          console.log('Turnstile callback received token:', t ? 'present' : 'missing', 'length:', t.length)
          setToken(t)
        },
        'error-callback': ()=>{
          console.log('Turnstile error callback')
          setToken('')
        }
      })
    }
    if(w.turnstile) render(); else (w.onloadTurnstileCallback = render)
    
    // Cleanup function to remove widget when component unmounts
    return () => {
      if(captchaRef.current) {
        captchaRef.current.innerHTML = ''
      }
    }
  },[])

  // Debug token changes
  useEffect(() => {
    console.log('Token state changed:', token ? 'present' : 'missing', 'length:', token.length)
  }, [token])

  const onSubmit = async (e:React.FormEvent)=>{
    e.preventDefault(); setErr(''); setStatus('sending')
    try {
      if (!token) throw new Error('Captcha not completed')
      if (!emailValid(email)) throw new Error('Please enter a valid email')
      await requestDownload({ email, itemId, captchaToken: token })
      setStatus('ok')
    } catch(e:any) {
      setErr(e.message || 'Request failed'); setStatus('err')
    }
  }

  if(status==='ok') return <p className="text-green-700">Thanks! Check your inbox for the link.</p>

  const emailOk = emailValid(email)
  const disabled = !emailOk || !token || status==='sending'
  
  // Debug logging
  console.log('EmailRequestForm Debug:', {
    email,
    emailOk,
    token: token ? 'present' : 'missing',
    tokenLength: token.length,
    status,
    disabled
  })

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <label className="block">
        <span className="text-sm">Email</span>
        <input
          type="email"
          required
          value={email}
          onChange={e=>setEmail(e.target.value)}
          className="mt-1 w-full rounded-xl border px-3 py-2"
          aria-label="Email address"
        />
        {!emailOk && email.length>0 && (
          <span className="mt-1 block text-xs text-red-600">
            Please enter a valid email address.
          </span>
        )}
      </label>

      <div ref={captchaRef} className="my-2" aria-label="Captcha"></div>
      {!token && (
        <p className="text-xs text-amber-700" aria-live="polite">
          Complete the CAPTCHA to enable the button.
        </p>
      )}

      <button disabled={disabled} className="rounded-2xl px-4 py-2 bg-black text-white disabled:opacity-50">
        {status==='sending'? 'Sending...' : 'Email me the link'}
      </button>

      {status==='err' && <p className="text-red-700">{err}</p>}
    </form>
  )
}
